import{
  FETCH_EVENTS_DATA, EVENTS_DATA_REQUEST
} from '../constants/events'

import {event} from '../utils/events/'

export function getOne(id) {
  return (dispatch) => {
    dispatch({
      type   : EVENTS_DATA_REQUEST,
      payload: {
        page: {
          data    : null,
          fetching: true,
        }
      }
    })

    event.getOne(id).then(data => {
      dispatch({
        type   : FETCH_EVENTS_DATA,
        payload: {
          page: {
            data    : data.events,
            fetching: false
          }
        }
      })
    });
  }
}
export function getFilterEventsListLimit() {
  return (dispatch) => {
    dispatch({
      type   : EVENTS_DATA_REQUEST,
      payload: {
        limit    : {
          data    : null,
          fetching: true
        }
      }
    })

    event.getFilterEventsLimit().then(data => {
      dispatch({
        type   : FETCH_EVENTS_DATA,
        payload: {
          limit    : {
            data    : data,
            fetching: false
          }
        }
      })
    });
  }
}
export function getFilterEventsList() {
  return (dispatch) => {
    dispatch({
      type   : EVENTS_DATA_REQUEST,
      payload: {
        data    : null,
        fetching: true
      }
    })

    event.getFilterEventsList().then(data => {
      dispatch({
        type   : FETCH_EVENTS_DATA,
        payload: {
          data    : data,
          fetching: false
        }
      })
    });
  }
}
export function addParticipant(formData) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_DATA_REQUEST,
      payload: {
        data: null,
        fetching: true,
        participation: {
          fetching: false,
          alerte: null
        }
      }
    });

    return new Promise((resolve, reject) => {
      event.addParticipant(formData)
        .then((d) => {
          let check = null;
          if (d.id_events_participant !== 0) {
            if (d.email === 1) {
              check = 1;
            }
            if (d.email === 2) {
              check = 2;
            }
          }
          dispatch({
            type: FETCH_EVENTS_DATA,
            payload: {
              data: d,
              fetching: false,
              participation: {
                fetching: true,
                alerte: check
              }
            }
          });
          resolve(d);  // Résoudre la promesse avec les données
        })
        .catch((error) => {
          // Si une erreur se produit, rejeter la promesse avec l'erreur
          reject(error);
        });
    });
  };
}

export function getListEventsParticipants() {
  return (dispatch) => {
    dispatch({
      type   : EVENTS_DATA_REQUEST,
      payload: {
        download:{
          datadw    : null,
          fetchingdw: true
        }
      }
    })
    event.getListEventsParticipant().then(data => {

      dispatch({
        type   : FETCH_EVENTS_DATA,
        payload: {
          download:{
            datadw    : data,
            fetchingdw: false
          }
        }
      })
    });
  }
}
export function getFilterEventsSearch(limit = null) {
  return (dispatch) => {
    dispatch({
      type   : EVENTS_DATA_REQUEST,
      payload: {
        search: {
          datasearch    : null,
          fetchingsearch: true
        }
      }
    })
    event.getFilterEventsSearchFetch(limit).then(data => {
      dispatch({
        type   : FETCH_EVENTS_DATA,
        payload: {
           search: {
              datasearch    : data,
              fetchingsearch: false
            }
        }
      })
    });
  }
}
export function getListParticipantParuser(formData) {
  return (dispatch) => {
    dispatch({
      type   : EVENTS_DATA_REQUEST,
      payload: {
        participation: {
          fetching: true,
          alerte: null
        }
      }
    })
    event.getListParticipantParuser(formData).then(d => {

      dispatch({
        type   : FETCH_EVENTS_DATA,
        payload: {
          participation: {
            fetching: false,
            alerte: d
          }
        }
      })
    });
  }
}
export function getLisDocument() {
  return (dispatch) => {
    dispatch({
      type   : EVENTS_DATA_REQUEST,
      payload: {
        document:{
          datadoc    : null,
          fetchingdoc: true
        }
      }
    })
    event.getLisDocuments().then(data => {

      dispatch({
        type   : FETCH_EVENTS_DATA,
        payload: {
          document:{
            datadoc    : data,
            fetchingdoc: false
          }
        }
      })
    });
  }
}
export function getAssociationEventsDocument() {
  return (dispatch) => {
    dispatch({
      type   : EVENTS_DATA_REQUEST,
      payload: {
        assoc:{
          datassoc    : null,
          fetchingassoc: true
        }
      }
    })
    event.getAssociationEventsDocuments().then(data => {
      dispatch({
        type   : FETCH_EVENTS_DATA,
        payload: {
          assoc:{
            datassoc    : data,
            fetchingassoc: false
          }
        }
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/eventsActions.js